import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"

/** 1:1 Port von admin/templates.py:.filter-bar. */
export function FilterBar({
  tenant, onTenantChange, children,
}: {
  tenant: string
  onTenantChange: (v: string) => void
  children?: React.ReactNode
}) {
  const { data } = useQuery({
    queryKey: ["tenants-dropdown"],
    queryFn: async () => {
      const { data, error } = await api.GET("/api/v1/tenants", {})
      if (error) throw new Error(String(error))
      return data
    },
    staleTime: 1000 * 60 * 5,
  })

  return (
    <div className="pp-filter-bar">
      <span className="filter-label">Tenant:</span>
      <select
        value={tenant}
        onChange={(e) => onTenantChange(e.target.value)}
        style={{ width: "auto" }}
      >
        <option value="">Alle Tenants</option>
        {data?.items.map((t) => (
          <option key={t.slug} value={t.slug}>{t.name}</option>
        ))}
      </select>
      {children}
    </div>
  )
}
